<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';
import mrfOnayDetailList from './DetailListItem.vue';

export default {
  name: 'mrfOnayDetailListDialog',
  mixins: [snackbarMixin],
  components: {mrfOnayDetailList},
  props: {
    isCreateMode: {
      type: Boolean,
    },
    item: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      visible: false,
      hasError: false,
      formData: {},
      detailList: [],
      pdfBlob: null,
    };
  },
  computed: {
    ...mapGetters('mrfOnayDetailListDialog', ['singularName']),
  },
  created() {
      this.formData = Object.assign({}, this.item);
  },
  mounted() {
    this.visible = true;
    this.initializeData();
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('mrfOnay',['getDetail', 'getDetailList', 'reject', 'approve']),
    ...mapMutations('mrfOnay', ['getList']),
    fetchData() {
      this.isLoading = true;
      this.getDetail(this.formData.pkart)
        .then((data) => {
          this.detailList = data.data;
          this.isInitialized = true;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    rejectRecord(){
      this.isLoading = true;
      this.reject([this.formData.pkart])
        .then(() => {
          this.showSuccessMessage(`${this.formData.mrF_No} numaralı MRF talebi reddedilmiştir.`);
          this.$emit('refresh');
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.isLoading = false;
          this.close();
        });
    },
    approveRecord() {
      this.isDeleting = true;
      this.isLoading = true;
      this.approve([this.formData.pkart])
        .then(() => {
          this.showSuccessMessage(`${this.formData.mrF_No} numaralı MRF talebi onaylanmıştır.`);
          this.$emit('refresh');
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.isLoading = false;
          this.close();
        });
    },
    initializeData() {
      var self = this;
      this.isLoading = true;
      Promise.all([self.getDetailList({id: self.formData.pkart})])
        .then(([detail]) => {
          self.detailList = detail.data;
          self.isInitialized = true;
          self.isLoading = false;
        }, () => {
          self.hasError = true;
          self.isLoading = false;
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="1080px">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        MRF Detay
      </v-card-title>

      <div v-if="isLoading" class="loading-container">
        <v-progress-circular
          indeterminate
          color="primary"
          size="50"
        />
        <p class="mt-3 grey--text">Veriler yükleniyor...</p>
      </div>

      <div v-else class="table-container">
        <v-simple-table class="elevation-1" fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Malzeme</th>
                <th>Miktar</th>
                <th>Birim</th>
                <th>Cost Code</th>
                <th>Cost Name</th>
                <th>Teslim Şekli</th>
                <th>Sabit Kıymet</th>
              </tr>
            </thead>
            <tbody>
              <mrfOnayDetailList v-for="(value, index) in detailList" :key="index" :item="value" />
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <v-card-actions>
        <v-spacer />
        <v-btn :loading="isLoading" @click="rejectRecord" color="red lighten-3" dark>
            Reddet
        </v-btn>
        <v-btn :loading="isLoading" @click="approveRecord" color="green lighten-3" dark>
        Onayla
        </v-btn>
        <v-btn color="red lighten-3" dark @click="close">
          Kapat
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.table-container {
  max-height: 400px;
  overflow-y: auto;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 40px;
}
</style>
